<ui-section class="h-full w-full p-6" title="Title Search" type="page">
	<div section-content class="flex flex-1 justify-between">
		<div>
			<div class="flex flex-1">
				<app-anchor
					*ngFor="let page of pages; let i = index"
					type="tab"
					[url]="page.page"
					(onClick)="setState(page)"
					[testHook]="testHooks.Link"
					>{{ i + 1 }}. {{ page.text }}</app-anchor
				>
			</div>
		</div>

		<div class="flex gap-x-5">
			<ui-button
				preset="EXTRA_LOW_EMPHASIS"
				(click)="skip()"
				label="Skip to overview"
				[testHook]="testHooks.SkipToOverviewButton"
			></ui-button>

			<app-teranet-balance></app-teranet-balance>
		</div>
	</div>
</ui-section>

<router-outlet class="hidden-router"></router-outlet>
